import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import NormalLayoutContainer from '../../../shared/NormalLayoutContainer'
import { PageTitle } from '../../../../components/page-title'
import useMutation from '../../../../hooks/useMutation'
import useQuery from '../../../../hooks/useQuery'
import QUERY_KEYS from '../../../../graphql/queryKeys'
import AddSiteTypeMutation from '../../../../graphql/mutations/addSiteType'
import siteTypesQuery from '../../../../graphql/queries/siteTypes'
import { captureErrorAndNotify } from '../../../../utilities/errorHandlers'
import notify from '../../../../utilities/notify'
import CreateSiteTypeForm from './components/CreateSiteTypeForm'
import CreateSiteTypeExplanation from './components/CreateSiteTypeExplanation'
import ExistingSiteTypeList from './components/ExistingSiteTypeList'

export default function HaulerSiteTypesNewContainer () {
  const history = useHistory()
  const { hauler } = useSelector(({ user: { user, hauler } }) => ({ user, hauler }))
  const [createErrors, setCreateErrors] = useState([])
  const [formValues, setFormValues] = useState({
    name: '',
    shortCode: ''
  })

  const { data: { siteTypes } = [], isLoading: siteTypesFetching } = useQuery(
    [
      QUERY_KEYS.siteTypes,
      hauler.id
    ],
    siteTypesQuery,
    {
      onError (error) {
        captureErrorAndNotify(error, 'Failed to retrieve existing site types')
      }
    }
  )

  const { mutate: addSiteTypeMutation, isLoading: isCreatingSiteType } = useMutation(AddSiteTypeMutation, {
    onSuccess ({ siteType }) {
      notify('success', `Successfully added Site Type ${siteType.shortCode}`)
      history.push('/hauler/site-types')
    },
    onError (error) {
      const errors = error?.message ?? ''
      const [errorBreakdown] = errors.split(':')
      captureErrorAndNotify(error, 'Unable to add site type')
      setCreateErrors(typeof errorBreakdown === 'string' ? errorBreakdown.split(',') : [])
    }
  })

  const cancelCreateResourceType = () => {
    history.push('/hauler/site-types')
  }

  const handleFormSubmit = (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault()
    }
    addSiteTypeMutation({
      name: formValues.name,
      shortCode: formValues.shortCode,
      haulerId: hauler.id
    })
  }

  return (
    <div>
      <NormalLayoutContainer showBackLink>
        <div className='container-fluid'>
          <PageTitle title='Create a New Site Type'>
            <button
              className='btn btn-link btn-lg pull-right push-down-super-small'
              onClick={cancelCreateResourceType}>
              Cancel
            </button>
          </PageTitle>

          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-7 col-lg-7'>
              <CreateSiteTypeForm
                isFetching={isCreatingSiteType}
                onSubmit={handleFormSubmit}
                cancelCreateResourceType={cancelCreateResourceType}
                formValues={formValues}
                setFormValues={setFormValues}
                resErrors={createErrors}
                clearErrors={() => setCreateErrors([])}
              />

            </div>
            <div className='col-xs-12 col-sm-12 col-md-4 col-md-offset-1 col-lg-4 col-lg-offset-1'>
              <div className='row'>
                <CreateSiteTypeExplanation />
                <hr />
                { !siteTypesFetching && (
                  <ExistingSiteTypeList
                    siteTypes={siteTypes}
                  />
                )
              }
              </div>
            </div>
          </div>

        </div>
      </NormalLayoutContainer>
    </div>
  )
}
